
// Initialize immediately and also on DOMContentLoaded
initializeYearPickers();
document.addEventListener('DOMContentLoaded', initializeYearPickers);

// Handle Turbo/Turbolinks if present
if (typeof Turbo !== 'undefined') {
  document.addEventListener("turbo:load", initializeYearPickers);
} else if (typeof Turbolinks !== 'undefined') {
  document.addEventListener("turbolinks:load", initializeYearPickers);
}

document.addEventListener('DOMContentLoaded', function() {
  // Verify year picker elements exist on the page
  const startYearDisplay = document.getElementById('start_year_display');
  const endYearDisplay = document.getElementById('end_year_display');
  
  if (!startYearDisplay || !endYearDisplay) {
    // The year picker is not on this page, no need to initialize
    return;
  }
  
  console.log("Year picker direct initialization");
  
  const startYearSliderContainer = document.getElementById('start_year_slider_container');
  const endYearSliderContainer = document.getElementById('end_year_slider_container');
  const startYearHidden = document.getElementById('funding_program_start_year_hidden');
  const endYearHidden = document.getElementById('funding_program_end_year_hidden');
  
  // Get initial values
  const startYearValue = parseInt(startYearHidden.value) || new Date().getFullYear();
  const endYearValue = parseInt(endYearHidden.value) || new Date().getFullYear() + 5;
  const currentYear = new Date().getFullYear();
  
  // Set more practical year range: 30 years before and after current year
  const minYear = currentYear - 30;
  const maxYear = currentYear + 30;
  
  console.log("Initial year values:", {start: startYearValue, end: endYearValue});
  console.log("Year range:", {min: minYear, max: maxYear});
});

function initializeYearPickers() {
  // Get all year pickers on the page
  const yearDisplayElements = document.querySelectorAll('.year-display');
  
  // If no pickers found, exit early
  if (yearDisplayElements.length === 0) {
    return;
  }
  
  console.log(`Found ${yearDisplayElements.length} year pickers`);
  
  // Set up each year picker
  yearDisplayElements.forEach(display => {
    // Get the ID from the display element (e.g., "start_year_display" -> "start_year")
    const id = display.id.replace('_display', '');
    console.log(`Setting up year picker: ${id}`);
    
    // Find related elements
    const container = document.getElementById(`${id}_slider_container`);
    const hiddenInput = document.getElementById(`funding_program_${id}_hidden`);
    const clearBtn = document.getElementById(`${id}_clear`);
    
    if (!container || !hiddenInput) {
      console.error(`Missing container or input for ${id}`);
      return;
    }
    
    // Get the selected year - default to current year for display purposes only, not for value
    const inputValue = hiddenInput.value;
    const selectedYear = inputValue ? parseInt(inputValue) : null;
    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 50;
    const maxYear = currentYear + 50;
    
    // Add clear button functionality if it exists
    if (clearBtn) {
      clearBtn.onclick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        // Clear the value
        hiddenInput.value = '';
        document.querySelector(`#${id}_display .year-value`).textContent = '—';
        
        // Remove clear button
        updateClearButtonVisibility(id, false);
        
        console.log(`${id} year cleared`);
      };
    }
    
    // Add click handler to display (using onclick for maximum compatibility)
    display.onclick = function(event) {
      // Check if we clicked on the clear button - if so, let that handler take over
      if (event.target.id === `${id}_clear` || event.target.closest(`#${id}_clear`)) {
        return;
      }
      
      event.preventDefault();
      event.stopPropagation();
      
      console.log(`${id} display clicked`);
      
      // Toggle visibility
      if (container.style.display === 'block') {
        container.style.display = 'none';
      } else {
        // Hide all other containers
        document.querySelectorAll('.year-slider-container').forEach(el => {
          el.style.display = 'none';
        });
        
        // Show this container
        container.style.display = 'block';
        
        // Initialize content if not already done
        if (!container.dataset.initialized) {
          setupYearPickerContent(id, selectedYear || currentYear, minYear, maxYear);
          container.dataset.initialized = 'true';
        }
      }
    };
  });
  
  // Close pickers when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.year-picker-container')) {
      document.querySelectorAll('.year-slider-container').forEach(el => {
        el.style.display = 'none';
      });
    }
  });
}

// Add a helper function to update clear button visibility
function updateClearButtonVisibility(id, show) {
  const displayEl = document.getElementById(`${id}_display`);
  let clearBtn = document.getElementById(`${id}_clear`);
  
  if (!displayEl) return;
  
  const actionsEl = displayEl.querySelector('.year-display-actions');
  
  if (show) {
    // If we need to show but button doesn't exist, create it
    if (!clearBtn) {
      clearBtn = document.createElement('i');
      clearBtn.className = 'bi bi-x-circle text-muted year-clear-btn me-2';
      clearBtn.id = `${id}_clear`;
      
      clearBtn.onclick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        // Clear the value
        const hiddenInput = document.getElementById(`funding_program_${id}_hidden`);
        hiddenInput.value = '';
        document.querySelector(`#${id}_display .year-value`).textContent = '—';
        
        // Hide the clear button
        updateClearButtonVisibility(id, false);
        
        console.log(`${id} year cleared`);
      };
      
      // Insert at beginning of actions container
      if (actionsEl) {
        actionsEl.insertBefore(clearBtn, actionsEl.firstChild);
      }
    }
  } else {
    // If we need to hide and button exists, remove it
    if (clearBtn) {
      clearBtn.remove();
    }
  }
}

function setupYearPickerContent(id, selectedYear, minYear, maxYear) {
  console.log(`Setting up content for ${id}`, {selectedYear, minYear, maxYear});
  
  const decades = document.getElementById(`${id}_decades`);
  const slider = document.getElementById(`${id}_slider`);
  
  if (!decades || !slider) {
    console.error(`Missing decades or slider element for ${id}`);
    return;
  }
  
  decades.innerHTML = '';
  
  // Create decade buttons
  const decadeStart = Math.floor(minYear / 10) * 10;
  const decadeEnd = Math.ceil(maxYear / 10) * 10;
  
  for (let decade = decadeStart; decade < decadeEnd; decade += 10) {
    const decadeBtn = document.createElement('div');
    decadeBtn.className = 'decade-btn';
    decadeBtn.textContent = `${decade}s`;
    
    // Highlight active decade
    if (decade <= selectedYear && selectedYear < decade + 10) {
      decadeBtn.classList.add('active');
    }
    
    // Add click handler
    decadeBtn.onclick = function() {
      document.querySelectorAll(`#${id}_decades .decade-btn`).forEach(btn => {
        btn.classList.remove('active');
      });
      decadeBtn.classList.add('active');
      populateYearGrid(id, decade, decade + 9, selectedYear);
    };
    
    decades.appendChild(decadeBtn);
  }
  
  // Initialize with the selected year's decade
  const initialDecade = Math.floor(selectedYear / 10) * 10;
  populateYearGrid(id, initialDecade, initialDecade + 9, selectedYear);
}

function populateYearGrid(id, startYear, endYear, selectedYear) {
  console.log(`Populating years for ${id}:`, {startYear, endYear, selectedYear});
  
  const slider = document.getElementById(`${id}_slider`);
  const hiddenInput = document.getElementById(`funding_program_${id}_hidden`);
  const yearDisplay = document.querySelector(`#${id}_display .year-value`);
  
  if (!slider || !hiddenInput || !yearDisplay) {
    console.error(`Missing required elements for ${id}`);
    return;
  }
  
  slider.innerHTML = '';
  
  // Create year buttons
  for (let year = startYear; year <= endYear; year++) {
    const yearBtn = document.createElement('div');
    yearBtn.className = 'year-btn';
    if (year === parseInt(selectedYear)) {
      yearBtn.classList.add('selected');
    }
    yearBtn.textContent = year;
    
    // Add click handler
    yearBtn.onclick = function() {
      const yearValue = year;
      
      // Update selection visual
      document.querySelectorAll(`#${id}_slider .year-btn`).forEach(btn => {
        btn.classList.remove('selected');
      });
      yearBtn.classList.add('selected');
      
      // Update value
      hiddenInput.value = yearValue;
      yearDisplay.textContent = yearValue;
      
      // Show the clear button
      updateClearButtonVisibility(id, true);
      
      console.log(`Selected ${id}: ${yearValue}`);
      
      // Close container with delay
      setTimeout(() => {
        document.getElementById(`${id}_slider_container`).style.display = 'none';
      }, 200);
    };
    
    slider.appendChild(yearBtn);
  }
}

// Make functions globally available
window.initializeYearPickers = initializeYearPickers;
window.setupYearPickerContent = setupYearPickerContent;
window.populateYearGrid = populateYearGrid;
